import { fromLegacyTimeZone, toIANATimeZone } from '@bingads-webui-universal/time-zone-converter';

export const fromServerDateTimeToLocalized = ({
  i18n,
  timeZoneId = 0, // UTC by default
  serverDateTime,
  format = {
    datetime: 'long',
  },
}) => i18n.formatDate(new Date(serverDateTime), {
  timeZone: toIANATimeZone(fromLegacyTimeZone(timeZoneId)),
  ...format,
});
